import { FieldErrors, UseFormRegisterReturn } from "react-hook-form";

import { Typography } from "~/common/components";
import SignUpFormLayout from "~/common/components/signUp/SignUpFormLayout";
import SignUpProgress from "~/common/components/signUp/SignUpProgress";
import { TermsAndConditionsSchemaType } from "~/common/utils/signUpSchemas";
import { TeamMemberTermsAndConditions } from "./TeamMemberTermsAndConditions";

interface TermsAndConditionsPageProps {
  onNext: () => Promise<void>;
  handleGoBack: () => void;
  step: number;
  totalSteps: number;
  register: (
    data: keyof TermsAndConditionsSchemaType,
  ) => UseFormRegisterReturn<string>;
  errors?: FieldErrors<TermsAndConditionsSchemaType>;
}

export const TermsAndConditionsPage = ({
  onNext,
  step,
  handleGoBack,
  totalSteps,
  register,
  errors,
}: TermsAndConditionsPageProps) => (
  <>
    <SignUpProgress step={step} totalSteps={totalSteps} />
    <SignUpFormLayout
      title="Terms & Conditions"
      handleData={onNext}
      handleGoBack={handleGoBack}
      submitLabel="Continue"
    >
      <div className="flex flex-col gap-6">
        <Typography>
          {`Please review and agree to PsychNow's BAA, Terms & Conditions, Privacy Policy and Free trial license to continue.`}
        </Typography>
        <TeamMemberTermsAndConditions
          register={register}
          error={errors?.termsAndConditions?.message}
        />
      </div>
    </SignUpFormLayout>
  </>
);
